/**
 * Cart Address Validation
 * Handles all validation logic for address fields
 */

(function() {
  'use strict';

  window.CartAddressValidation = {
    /**
     * Show validation error on input
     */
    showError(input, message) {
      input.setCustomValidity(message);
      input.reportValidity();
      input.classList.add('cart-address-error');
      
      // Remove error class after user starts typing
      const removeError = () => {
        input.classList.remove('cart-address-error');
        input.removeEventListener('input', removeError);
      };
      input.addEventListener('input', removeError, { once: true });
    },

    /**
     * Clear validation error from input
     */
    clearError(input) {
      input.setCustomValidity('');
      input.classList.remove('cart-address-error');
    },


    /**
     * Validate all required fields
     * @param {HTMLElement} container - The cart address container
     * @param {boolean} showErrors - Whether to show errors and focus
     * @returns {boolean} - Whether all fields are valid
     */
    validateAll(container, showErrors = true) {
      const entryInput = container.querySelector('[data-prop="Entry"]');
      const floorInput = container.querySelector('[data-prop="Floor"]');
      const elevatorInputs = container.querySelectorAll('[data-prop="Has elevator"]');
      
      let isValid = true;
      let firstInvalidField = null;

      // Validate entry
      if (!entryInput || !entryInput.value.trim()) {
        if (showErrors) {
          entryInput?.setCustomValidity('שדה חובה');
          if (entryInput && !firstInvalidField) firstInvalidField = entryInput;
        }
        isValid = false;
      } else {
        entryInput?.setCustomValidity('');
      }

      // Validate floor
      if (!floorInput || !floorInput.value.trim()) {
        if (showErrors) {
          floorInput?.setCustomValidity('שדה חובה');
          if (floorInput && !firstInvalidField) firstInvalidField = floorInput;
        }
        isValid = false;
      } else {
        floorInput?.setCustomValidity('');
      }

      // Validate elevator
      const elevatorChecked = Array.from(elevatorInputs).some(input => input.checked);
      if (!elevatorChecked && elevatorInputs.length > 0) {
        if (showErrors) {
          elevatorInputs[0].setCustomValidity('אנא בחר אפשרות');
          if (!firstInvalidField) firstInvalidField = elevatorInputs[0];
        }
        isValid = false;
      } else if (elevatorInputs.length > 0) {
        elevatorInputs.forEach(input => input.setCustomValidity(''));
      }

      // Report validity and focus if showing errors
      if (showErrors && !isValid && firstInvalidField) {
        firstInvalidField.reportValidity();
        firstInvalidField.focus();
      }

      return isValid;
    }
  };
})();

